module.exports = __webpack_public_path__ + "static/media/30.99bf4278.jpg";